import { createRef, useState } from 'react'
import { Link as GatsbyLink } from 'gatsby'
import { useUpdateEffect } from '@react-hookz/web'
import { withHover } from '@monobits/core'
import { Section } from '@monobits/components'
import { useBreakpoint } from '@boiler/utils'

import { useComponent, useLinkFrom } from '../hooks'

const Cell = withHover(
  ({
    withInview = true,
    children,
    title,
    id,
    isStatic = false,
    showIcon,
    link = '',
    href = null,
    sx,
    onHover = () => {},
    hover,
    disabled,
    linkState = {},
    forwardedRef = createRef(),
    image,
    ...props
  }) => {
    const from = useLinkFrom() ?? ''
    const { collapsible } = useComponent() ?? {}
    const { index } = useBreakpoint()
    const [init, setInit] = useState(false)

    const isLink = !!link
    const isExternalLink = !!href

    const allowed = index > 1

    useUpdateEffect(() => {
      onHover && onHover(!!hover)
    }, [hover])

    useUpdateEffect(() => {
      !!hover && !!allowed && !init && setInit(true)
      !allowed && !!init && setInit(false)
    }, [hover, allowed])

    return collapsible.head({
      init,
      image: !!allowed && image,
      sx: { '--speed': 'var(--ui-duration)', '--ease': 'var(--ui-ease)', ...sx },
      props: {
        wrapper: {
          ref: forwardedRef,
          'data-handle': id,
          'data-selected': !!hover,
          'data-disabled': !!disabled,
          'data-static': !!isStatic,
          ...props,
        },
        button: isLink
          ? { as: GatsbyLink, to: link, state: { from, ...linkState } }
          : !!isExternalLink
          ? { as: 'a', href, target: '_blank', rel: 'noreferrer noopener' }
          : {},
      },
      value: title,
      showIcon: showIcon ?? !!isLink,
      withContent: !!!isLink,
      withInview,
      isLink,
      link,
      id,
    })
  },
  { mouse: true }
)

const Table = ({ items, id = '', children, ...props }) => {
  const { collapsible } = useComponent() ?? {}

  return (
    <Section {...collapsible?.section} data-single={true} {...props}>
      <div>{children}</div>
    </Section>
  )
}

Table.Cell = Cell

export default Table
